import type { AgencyInfo, LiveVehicle, RouteSchedule, SystemStats, TripDetail } from "./types"

export async function fetchBootstrap() {
  const res = await fetch("/api")
  if (!res.ok) throw new Error("failed to load bootstrap")
  return res.json() as Promise<{
    agencies: Record<string, AgencyInfo>
    shapeColors: Record<string, string>
    shapeRoutes: Record<string, string>
    vehicleCount: number
    vehicleUpdatedAt: number
  }>
}

export async function fetchVehicles() {
  const res = await fetch("/api/vehicles")
  if (!res.ok) throw new Error("failed to load vehicles")
  return res.json() as Promise<{
    updatedAt: number
    vehicles: LiveVehicle[]
    stats: SystemStats
  }>
}

export async function fetchRouteSchedule(routeId: string) {
  const res = await fetch(`/api/routes/${encodeURIComponent(routeId)}/schedule`)
  if (!res.ok) throw new Error("failed to load schedule")
  return res.json() as Promise<RouteSchedule>
}

export async function fetchRouteTrips(routeId: string) {
  const res = await fetch(`/api/routes/${encodeURIComponent(routeId)}/trips`)
  if (!res.ok) throw new Error("failed to load trips")
  return res.json() as Promise<{ trips: any[]; vehicles: LiveVehicle[] }>
}

export async function fetchTripDetail(tripId: string) {
  const res = await fetch(`/api/trips/${encodeURIComponent(tripId)}`)
  if (!res.ok) throw new Error("failed to load trip")
  return res.json() as Promise<TripDetail>
}

export async function fetchShapesBuffer() {
  const res = await fetch("/api/shapes.shp")
  if (!res.ok) throw new Error("failed to load shapes")
  return res.arrayBuffer()
}
